import { useRequest } from 'ahooks'

import { inviteAuctionApplyApi } from '@eastcoal/api/trade/applyOperation/inviteAuctionApply'

import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'
import { useRemoteTransferStore } from '@eastcoal/common/components/RemoteTransfer/Store/hooks/useStore'
import { isEmpty, pick } from '@eastcoal/common/utils/object'

import { useAuctionListStore } from '../../../../../Store/hooks/useStore'
import { useBidMemberListModalStore } from '../../Store/hooks/useContext'

export const ApplyInviteButton = () => {
  const { tableRef } = useBidMemberListModalStore()

  const { currentAuction } = useAuctionListStore(state =>
    pick(state, ['currentAuction'])
  )

  const { value, setValue, reload } = useRemoteTransferStore(state =>
    pick(state, ['value', 'setValue', 'reload'])
  )

  const auctionId = currentAuction?.id

  const { loading, refresh } = useRequest(
    () =>
      inviteAuctionApplyApi({
        auctionId,
        users: value
      }),
    {
      manual: true,
      onSuccess() {
        setValue([])
        reload(true)
        tableRef.current?.reload()
      }
    }
  )

  return (
    <ThrottleButton
      key='inviteButton'
      disabled={isEmpty(value)}
      loading={loading}
      type='primary'
      onClick={refresh}
    >
      邀请
    </ThrottleButton>
  )
}
